<div
  echarts
  class="chart"
  [style.--chart-height.px]="chartHeight()"
  [options]="adaptedOptions()"
  [initOpts]="initOpts"
></div>

<div class="sliders-panel">
  <dojo-slider
    param="a"
    [min]="-3"
    [max]="3"
    [step]="0.1"
    [value]="a()"
    [editable]="true"
    color="orange"
    (valueChange)="onAChange($event)"
  />
  <dojo-slider
    param="b"
    [min]="-5"
    [max]="5"
    [step]="0.1"
    [value]="b()"
    [editable]="true"
    color="indigo"
    (valueChange)="onBChange($event)"
  />
</div>

<div class="formulas-panel">
  <div class="formula-row" [innerHTML]="formulaEHtml()"></div>
  <div class="formula-row" [innerHTML]="formulaVarHtml()"></div>
  <div class="formula-row" [innerHTML]="formulaSigmaHtml()"></div>
</div>
